var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "view",
          rawName: "v-view",
          value: _vm.onViewportIntersection,
          expression: "onViewportIntersection",
        },
      ],
      staticClass: "rb-lazy-payment-icon",
    },
    [
      !_vm.loaded
        ? _c("div", { staticClass: "rb-lazy-payment-icon--skeleton" })
        : _c("div", [
            _c(
              "span",
              {
                staticClass: "common__icon",
                class: "common__icon--" + _vm.icon,
                style: _vm.inlineStyle,
              },
              [_vm._t("default")],
              2
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }